import { useEffect } from 'react';
import { useMagicSearch, useMagicSearchContext } from './MagicSearchContext';

export function StartPlugins() {
  const { plugins, searchStore } = useMagicSearchContext();

  const { state } = useMagicSearch(s => ({
    state: s.state,
  }));

  // Sync search results with the store
  useEffect(() => {
    searchStore?.getState().searchResults(state, plugins);
  }, [state, plugins, searchStore]);

  return null;
}
